import React from "react";
import Container from "@material-ui/core/Container";
import { makeStyles, styled } from "@material-ui/core/styles";
import { Chip, colors } from "@material-ui/core";
import LocalAtmIocn from "@material-ui/icons/AttachMoney";
import TransformIcon from "@material-ui/icons/TransformOutlined";
import PaymentsIcont from "@material-ui/icons/PaymentTwoTone";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  chip: {
    paddingLeft: "10px",
    paddingRight: "20px",
    // marginLeft: "20px",
    // color:colors.orange[800],
    fontSize: "16px",
  },
}));

export const paymentType = [
  { id: "1", name: "cash", icon: <LocalAtmIocn /> },
  { id: "2", name: "check", icon: <PaymentsIcont /> },
  { id: "3", name: "translate", icon: <TransformIcon /> },
];

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const SalaryFilter = (props) => {
  const { t } = useTranslation(["forms"]);

  const {params, setParams,AutoOptions,valueAutos,setValueAutos} = props;
  const classes = useStyles();
  const payments = paymentType;
  const onChangeA = (value) => {
    if (value==1|| value=="1"){
        setValueAutos({...valueAutos,safe_bank_id:AutoOptions.Stocks[0]})
        setParams({...params,type: value,safe_bank_id:AutoOptions.Stocks[0].id});
    }else{
        setValueAutos({...valueAutos,safe_bank_id:AutoOptions.Banks[0]})
        setParams({...params,type: value,safe_bank_id:AutoOptions.Banks[0].id});
    }

  };

  return (
    <Container 
      style={{
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        listStyle: "none",
        padding: "10px",
        margin: "0px",
      }}
      component="ul"
    >
      {payments.map((x) => {
        return (
          <ListItem key={x.id}  >
            {x.id == params.type ? (
              <Chip 
                className={classes.chip}
                label={t(x.name)}
                icon={x.icon}
                style={{ backgroundColor:  "#87ceeb", color: "#fff" }}
                clickable
              />
            ) : (
              <Chip
                className={classes.chip}
                label={t(x.name)}
                icon={x.icon}
                variant="outlined"
                // color="secondary"
                style={{ color: colors.grey[800] }}
                onClick={() => {
                    onChangeA(x.id);
                    // setParams({...params,type: x.id});
                }}
              />
            )}
          </ListItem>
        );
      })}
    </Container>
  );
};

export default SalaryFilter;
